import React, { useState, useEffect } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiPhoneCall, FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { name: 'Home', href: '#home' },
    { name: 'Company', href: '#company' },
    { name: 'Technology', href: '#technology' },
    { name: 'Careers', href: '#careers' },
    { name: 'News', href: '#news' },
    { name: 'Contact Us', href: '#contact' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-navy/90 backdrop-blur-md border-b border-cyan/10 shadow-[0_4px_30px_rgba(0,240,255,0.05)]' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex-shrink-0">
            <a href="#home" className="font-heading text-2xl font-bold tracking-wider flex items-center gap-2">
              <span className="text-white">Vitro</span>
              <span className="text-cyan text-glow">techworld</span>
            </a>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              {links.map((link) => (
                <a key={link.name} href={link.href} className="text-slate-300 hover:text-cyan transition-colors px-3 py-2 rounded-md text-sm font-medium">
                  {link.name}
                </a>
              ))}
            </div>
          </div>

          <div className="hidden md:flex items-center">
            <a href="tel:+918624876371" className="flex items-center gap-2 bg-gradient-to-r from-cyan/10 to-transparent border border-cyan/30 text-cyan px-4 py-2 rounded-full hover:bg-cyan hover:text-navy transition-all duration-300 ease-in-out glow-border">
              <SafeIcon icon={FiPhoneCall} />
              <span className="font-semibold text-sm">+91 8624876371</span>
            </a>
          </div>

          <div className="md:hidden flex items-center">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-cyan p-2">
              <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-charcoal border-b border-cyan/10 px-2 pt-2 pb-3 space-y-1 sm:px-3">
          {links.map((link) => (
             <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-slate-300 hover:text-cyan block px-3 py-2 rounded-md text-base font-medium">
               {link.name}
             </a>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;